import Vue from 'vue';
import { State } from '@/store/state';
import { ConnectorConfig } from '@/models/ConnectorConfig';
import { ConnectorSyncStatus } from '@/store/state/ConnectorState';

export const connectorMutations = {
  setConnectors(state: State, connectors: ConnectorConfig[]) {
    state.connector.connectors = connectors;
  },
  setConnectorLoading(state: State, isLoading: boolean) {
    state.connector.isLoading = isLoading;
  },
  setConnectorError(state: State, error: string | null) {
    state.connector.error = error;
  },
  addConnector(state: State, connector: ConnectorConfig) {
    state.connector.connectors.push(connector);
  },
  removeConnector(state: State, connectorId: string) {
    state.connector.connectors = state.connector.connectors.filter((c) => c.id !== connectorId);
    Vue.delete(state.connector.syncStates, connectorId);
  },
  updateConnector(state: State, connector: ConnectorConfig) {
    const idx = state.connector.connectors.findIndex((c) => c.id === connector.id);
    if (idx >= 0) {
      state.connector.connectors.splice(idx, 1, connector);
    }
  },
  setConnectorSyncState(state: State, payload: { connectorId: string; syncStatus: ConnectorSyncStatus }) {
    Vue.set(state.connector.syncStates, payload.connectorId, payload.syncStatus);
  },
  clearConnectorSyncState(state: State, connectorId: string) {
    Vue.delete(state.connector.syncStates, connectorId);
  },
  hydrateConnectorSyncStates(state: State, syncStates: Record<string, ConnectorSyncStatus>) {
    state.connector.syncStates = { ...syncStates };
  },
};
